import { render, staticRenderFns } from "./main_menu.vue?vue&type=template&id=b537485a&"
import script from "./main_menu.vue?vue&type=script&lang=js&"
export * from "./main_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports